import {
    OnlyWhenUrgencySignalsEnabled,
    UrgencyCategories,
    UrgencyMessages,
} from '@eventbrite/urgency-signals';
import React from 'react';
import { useIsServerSideRendered } from '../hooks/useIsServerSideRendered';

export const UrgencySignalsWrapper: React.FC<{}> = ({}) => {
    const { isServerSideRendered } = useIsServerSideRendered();

    if (isServerSideRendered) {
        return null;
    }

    return (
        <OnlyWhenUrgencySignalsEnabled>
            <div className="urgency-signals">
                <UrgencyMessages />
                <UrgencyCategories />
            </div>
        </OnlyWhenUrgencySignalsEnabled>
    );
};
